export const TALKROBIN_SET_USER = 'TALKROBIN_SET_USER';
export const TALKROBIN_RESET = 'TALKROBIN_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
